import { Utils } from 'choerodon-ui/dataset';
const normalizeLanguage = Utils.normalizeLanguage;
export default normalizeLanguage;
